/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricsCollectionError
 */
export interface MetricsCollectionError {
    /**
     * 
     * @type {string}
     * @memberof MetricsCollectionError
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof MetricsCollectionError
     */
    stackTrace?: string;
}

export function MetricsCollectionErrorFromJSON(json: any): MetricsCollectionError {
    return MetricsCollectionErrorFromJSONTyped(json, false);
}

export function MetricsCollectionErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricsCollectionError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'stackTrace': !exists(json, 'stackTrace') ? undefined : json['stackTrace'],
    };
}

export function MetricsCollectionErrorToJSON(value?: MetricsCollectionError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'stackTrace': value.stackTrace,
    };
}

